import Layout from 'components/Layout';
import HeadWithNoIndexAndNoFollow from 'components/Seo/HeadWithNoIndexAndNoFollow';

import ConsentsList from './ConsentsList';
import Heading from './Heading';
import PageDescription from './PageDescription';
import Sidebar from './Sidebar';

const CookiesPage = () => (
  <>
    <Heading className="mb-8 md:mb-10" />
    <HeadWithNoIndexAndNoFollow
      description="Ajuste suas preferencias de cookies"
      title="Política de Cookies"
    />
    <Layout
      gridProps={{ className: 'px-3 lg:px-0 mb-14' }}
      sidebarComponent={<Sidebar />}
      maxWidthOnMobileDevices
    >
      <PageDescription />
      <ConsentsList className="mt-6" />
    </Layout>
  </>
);

export default CookiesPage;
